import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { IssuesCategorySummary } from '../../../../shared/issuesV2';

// GET /api/v2/issues/categories returns live current active-issue counts per category.
function fetchIssueCategorySummary(teamIds: number[], releaseGroupId: number | null) {
  // A release group is release-scoped, so it takes precedence over (and replaces) the team filter.
  const params = releaseGroupId != null
    ? `releaseGroupId=${releaseGroupId}`
    : teamIds.map((teamId) => `teamId[]=${teamId}`).join('&');
  return get<IssuesCategorySummary>(`/api/v2/issues/categories?${params}`);
}

/**
 * Live current active-issue counts per category for the Global Issue CSV Export card's metrics preview.
 * Scoped to the selected release group when one is chosen, otherwise across the selected teams/groups.
 * Sourced from `GET /api/v2/issues/categories` (the live status summary).
 */
export function useIssueCountsPreview(teamIds: number[], releaseGroupId: number | null, shouldFetch: boolean) {
  return useQuery<IssuesCategorySummary>({
    queryKey: ['issue-category-summary-preview', teamIds, releaseGroupId],
    queryFn: () => fetchIssueCategorySummary(teamIds, releaseGroupId),
    enabled: shouldFetch && (releaseGroupId != null || teamIds.length > 0),
  });
}
